import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoPageModule, PoTableModule, PoLoadingModule, PoAccordionModule, PoButtonModule, PoFieldModule, PoDividerModule, PoTabsModule, PoDynamicModule, PoModalModule, PoWidgetModule, PoInfoModule } from '@po-ui/ng-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReembolsoDespesasListComponent } from './reembolso-despesas-list/reembolso-despesas-list.component';
import { ReembolsoDespesasRoutingModule } from './reembolso-despesas-routing.module';




@NgModule({
    declarations: [ReembolsoDespesasListComponent
    ],
    imports: [
        CommonModule,
        ReembolsoDespesasRoutingModule,
        PoPageModule,
        PoTableModule,
        PoLoadingModule,
        PoAccordionModule,
        FormsModule,
        ReactiveFormsModule,
        PoButtonModule,
        PoFieldModule,
        PoDividerModule,
        PoTabsModule,
        PoDynamicModule,
        PoModalModule,
        PoWidgetModule,
        PoInfoModule
    ]
})
export class ReembolsoDespesaModule { }
